import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MenuService } from "../../master/services";
import { Title } from "@angular/platform-browser";

@Component({
	selector: "app-login-page",
	templateUrl: "./login-page.component.html",
	styleUrls: ["./login-page.component.css"],
})
export class LoginPageComponent implements OnInit {
	constructor(private menuService: MenuService, private activatedRoute: ActivatedRoute, private title: Title) {}

	ngOnInit(): void {
		this.title.setTitle("CAASS-Login");
		this.menuService.MenuIsLoaded(false, null);

		//
		//	Check if using Normal Login or SU Page
		//
		this.ErrorB64 = this.activatedRoute.snapshot.params["ErrorB64"];
		if (this.ErrorB64 != undefined && this.ErrorB64 != "") {
			if (String(this.ErrorB64).toLowerCase() == "su") {
				this.SuLoginEnabled = true;
			}
		}

		this.LoginInit = true;
	}

	/////////////////////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////////////////////

	LoginInit: boolean = false;
	SuLoginEnabled: boolean = false;

	ErrorB64: string = "";

	CAASS_VERSION: string = "v10.16"; //Update this when updating Index.Html

	/////////////////////////////////////////////////////////////////////////////////////////////
}
